export default "__VITE_ASSET__DvwniJ2y__"